import React, { useContext } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { FormGroup, FormControl } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillCalendarEventFill } from "react-icons/bs";

import SelectPcp from "../../forms/SelectPcp";
import ViewDocument from "../../../shared/ViewDocument";
import FieldError from "../../../shared/FieldError";
import SelectVisitType from "../../forms/SelectVisitType";
import { Settings } from "../../../helpers/Contexts";

const CprCompleted = ({ task, isCompleted }) => {
  const settings = useContext(Settings);
  const isPcpVisit = settings.visit_types.find((i) =>
    i.name == task.cpr.procedure_type ? true : false
  );

  const CprCompletedSchema = isPcpVisit
    ? Yup.object().shape({
        pcp: Yup.string().nullable(),
        document: Yup.mixed(),
        procedure_type: Yup.string(),
        procedure_type_id: Yup.number(),
        completed_on_date: Yup.date().required("Completed on date is required."),
      })
    : Yup.object().shape({
        pcp: Yup.string().nullable(),
        document: Yup.mixed(),
        completed_on_date: Yup.date().required("Completed on date is required."),
      });

  let initValues = isCompleted
    ? {
        pcp: task.cpr.attending_provider ? task.cpr.attending_provider : "",
        date: task.cpr.completed_on_date,
        completed_on_date: task.cpr.completed_on_date,
        document: task.cpr.document.url && task.cpr.document.url,
      }
    : {
        pcp: "",
        completed_on_date: "",
        date: "",
        document: "",
      };

  if (isPcpVisit) {
    initValues = {
      ...initValues,
      procedure_type: task.cpr.procedure_type,
      procedure_type_id: settings.visit_types.filter((i) => i.name == task.cpr.procedure_type)[0]
        .id,
    };
  }

  return (
    <>
      <Formik
        initialValues={{ ...initValues }}
        validationSchema={CprCompletedSchema}
        onSubmit={(values) => {
          if (values.date && values.pcp) {
            const formData = new FormData();
            formData.append("task[id]", task.id);
            formData.append("task[sub_status_list_id]", task.cpr.sub_status_list_id);
            formData.append("task[event]", "cpr_completed");
            formData.append("task[completed_on_date]", values.completed_on_date);
            !task.cpr.document.url && formData.append("task[document]", values.document);
            values.pcp && formData.append("task[attending_provider]", values.pcp);
            if (values.procedure_type_id) {
              formData.append("task[procedure_type_id]", values.procedure_type_id);
            }
            return task.formHandler(formData);
          }
        }}
      >
        {({ values, setFieldValue, setTouched, errors, isSubmitting }) => {
          return (
            <>
              <Form>
                {isPcpVisit && (
                  <SelectVisitType
                    name="procedure_type"
                    setFieldValue={setFieldValue}
                    showPopup={true}
                    value={values.procedure_type_id}
                  />
                )}
                <label>
                  {"Attending Provider "}
                  <small id="from">
                    Usually the provider who completed Care Plan Requirement with patient
                  </small>
                </label>

                {task.cpr.procedure_type == "Lab/Diagnostic Only" ? (
                  <select disabled className="dropdown-select">
                    <option value={""}>{"N/A for Lab/Diagnostic Only"}</option>
                  </select>
                ) : (
                  <>
                    {isPcpVisit ? (
                      <>
                        {task.patient.out_of_area ? (
                          <Field name="pcp" placeholder={""} />
                        ) : (
                          <SelectPcp name="pcp" pcpRequired={true} required={false} setFieldValue={setFieldValue} />
                        )}
                      </>
                    ) : (
                      <Field name="pcp" placeholder={""} />
                    )}
                  </>
                )}

                {!values.pcp && task.cpr.procedure_type !== "Lab/Diagnostic Only" ? (
                  <FieldError error={"Attending provider is required"} />
                ) : null}
                <label>Completed On Date</label>
                <div className={"flex datefield-wrapper full-width"}>
                  <Field name="date" placeholder="Completed on date is required">
                    {({ field, meta }) => {
                      return (
                        <>
                          <BsFillCalendarEventFill className="calendar-icon" />
                          <ReactDatePicker
                            className="datepicker"
                            autoComplete="off"
                            {...field}
                            maxDate={settings.me.environment == "production" ? new Date() : null}
                            dateFromat={"YYYY-MM-dd"}
                            onChange={(date) => {
                              setFieldValue("completed_on_date", date);
                              setFieldValue("date", date.toISOString().slice(0, 10));
                            }}
                          />
                        </>
                      );
                    }}
                  </Field>
                </div>
                {!values.date ? <FieldError error={"Completed on date is required"} /> : null}

                {task.cpr.document.url && (
                  <div>
                    <ViewDocument url={task.cpr.document.url} />
                  </div>
                )}
                {!task.cpr.document.url && (
                  <>
                    <label>Attach Results/Visit Summary (If Available)</label>
                    <FormGroup controlId="formFile" className="mb-3">
                      <FormControl
                        type="file"
                        onChange={(e) => setFieldValue("document", e.target.files[0])}
                      />
                    </FormGroup>
                  </>
                )}
                <button className="check accent-bg" type="submit" disabled={isSubmitting}>
                  Submit CPR Status Check
                </button>
              </Form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default CprCompleted;
